/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
// import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

import "swiper/css/bundle";

import "./colors.scss";

import "@greeter/theme";

import "./i18n";

import "animate.css";

// For v6
import { setupIonicReact, getPlatforms } from "@ionic/react";
const platforms = new Set(getPlatforms());

setupIonicReact({
  swipeBackEnabled: false,
  mode: !platforms.has("desktop") ? "ios" : undefined,
});
